module.exports = __webpack_public_path__ + "img/a22ba7f4db4d73e52f9d665efa0ad85d.png";